import { Design } from '@app/types';
import { createDesignChangeMap } from '../../versioning';

export interface HasLocalChangesProps {
  design: Design;
  latestDesign: Design;
}

/** Checks to see if the design has changes compared to the latest version. */
export function hasLocalChanges({
  design,
  latestDesign
}: HasLocalChangesProps = {
  design: window.apm.serialized,
  latestDesign: window.apm.latestSerialized!
}): boolean {
  return Object.keys(
    createDesignChangeMap(design, latestDesign)
  ).length !== 0;
}
